import './reset.css';
import './App.css';

// my components
import Nav from './components/Nav';
import Grid from './components/Grid';

function App() {
  return (
    <main>
      <Nav/>
      <Grid/>
    </main>
  );
}

export default App;
